
import { Component, Vue } from 'vue-property-decorator';
import UserIconMenu from '@/app/components/user/UserIconMenu.vue';
import NotificationsModal from 'ah-notifications/src/components/notifications/NotificationsModal.vue';
import UpdatesModal from '@/app/components/updates/UpdatesModal.vue';
import SideNavMobile from './SideNavMobile.vue';
import NeedHelpButton from '../common/NeedHelpButton.vue';
import { XHedgeEventBusEvents } from '@/app/constants/events';
import { FileExportsModal } from 'ah-notifications';
import { useAuthStore } from '@/app/store/authModule';
import { useNotificationsStore } from 'ah-notifications/src/store';

@Component({
  components: {
    UserIconMenu,
    SideNavMobile,
    NotificationsModal,
    UpdatesModal,
    NeedHelpButton,
    FileExportsModal,
  },
})
export default class PrivateTopNav extends Vue {
  $refs!: {
    updatesModal: UpdatesModal;
  };

  private menuExpanded = false;

  get notificationsStore() {
    return useNotificationsStore();
  }

  created() {
    this.$eventBus.$on(XHedgeEventBusEvents.SHOW_UPDATES, this.showUpdates);
  }

  destroyed() {
    this.$eventBus.$off(XHedgeEventBusEvents.SHOW_UPDATES, this.showUpdates);
  }

  showUpdates() {
    this.$refs.updatesModal.show();
  }

  get authStore() {
    return useAuthStore();
  }

  get hasUnreadNotifications() {
    return this.notificationsStore.unreadCount > 0;
  }

  get hasUnreadFileExports() {
    return this.notificationsStore.fileExportUnreadCount > 0;
  }

  get hasUnreadUpdates() {
    return this.notificationsStore.updateUnreadCount > 0;
  }

  toDashBoard() {
    this.$router.push('/dashboard');
  }

  get user() {
    return this.authStore.loggedInIdentity;
  }

  toggleMenu() {
    this.menuExpanded = !this.menuExpanded;
  }
}
